export const API_PATH_ApiTrafficStudyDelete = '/services/traffic-studies/apiTrafficStudyDelete';
